import type { GetChatResponse } from '@/api/chat/getChat';

/**
 * A chat that was created (e.g. by a file upload) but never prompted. Shows the welcome page again.
 * Not for case chats or read-only chats.
 */
export const isUnpromptedChat = (chat: GetChatResponse | undefined): boolean =>
  Boolean(chat && chat.canEdit && !chat.matter && chat.chatMessages.length === 0);
